
        Component.define('template-header', (el, params) => {
            /**
 * Cada componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el             = $(el);
const $btnMobile      = $el.find('.box-menu-mobile');
const $hamburger      = $el.find('.menu-mobile');
const $menu           = $el.find('.menu');
const $linkMenu       = $el.find('.menu a');
const $btnOndeComprar = $el.find('.btn-onde-encontrar');

const open = () => {
    $hamburger.toggleClass('is-active');
    $menu.slideToggle();
    $el.toggleClass('menu-open');
    $body.toggleClass('overflow-hidden');
    $html.toggleClass('overflow-hidden');
};

const close = () => {
    $hamburger.removeClass('is-active');
    $menu.slideUp();
    $el.removeClass('menu-open');
    $body.removeClass('overflow-hidden');
    $html.removeClass('overflow-hidden');
};

$btnMobile.on('click', function(){
    open();
});

$linkMenu.on('click', function(){
    if ($hamburger.is('.is-active')) {
        close();
    }
});

$btnOndeComprar.on('click', function () {
    $document.trigger('ga-onde-comprar:click');
});

$body.on('click', function (e) {
    if ($hamburger.is('.is-active') && !$(e.target).closest('[data-component="template-header"]').length) {
        close();
    }
});

$window
    .on('scroll', function() {
        let posScroll = $window.scrollTop();

        if($('#page-home').length > 0){
            $el.addClass('header-bg');
        } else {
            if (wW > 980) {
                if (posScroll > 50) {
                    $el.addClass('header-bg');

                } else {
                    $el.removeClass('header-bg');
                }

            }
        }

    })
    .on('resize', function() {
        if (wW > 980) {
            $el.removeClass('menu-open');
            $hamburger.removeClass('is-active');
            $menu.attr('style', '');
        }
    });

        });